import { createSlice } from '@reduxjs/toolkit';
import { NetworkErrors, NetworkState } from './network-types';

const initialState: NetworkState = {
    error: undefined,
    loadingDashboardInit: false,
};

const slice = createSlice({
    name: 'network',
    initialState,
    reducers: {
        loadingDashboardInit: state => ({
            ...state,
            loadingDashboardInit: true,
        }),
        finishedDashboardInit: state => ({
            ...state,
            loadingDashboardInit: false,
        }),
        timeout: state => ({
            ...state,
            error: NetworkErrors.SessionTimeout,
        }),
    },
});

export const { name, actions, reducer } = slice;
export const { timeout, loadingDashboardInit, finishedDashboardInit } = actions;
export default slice;
